export default __webpack_public_path__ + "static/Sketch6-e3ae1f9ee15be3489ff2f2150fa69222.jpg";